import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/signIn/storedActivities.query.gql"
import type {
  StoredActivitiesQuery,
  StoredActivitiesQueryVariables,
} from "@/v2-backoffice-client/signIn/__types__/storedActivities.query"

type Options = QueryHookOptions<
  StoredActivitiesQuery,
  StoredActivitiesQueryVariables
>

export function useStoredActivitiesQuery(options?: Options) {
  return useQuery<StoredActivitiesQuery, StoredActivitiesQueryVariables>(
    query,
    options,
  )
}
